import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Camera Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-camera-outline',
    templateUrl: './icon-camera-outline.component.html',
    styleUrls: ['./icon-camera-outline.component.scss'],
    standalone: false
})
export class IconCameraOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
